import { useState, useEffect } from 'react';
import { Collapse } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';

const ToggleBlock = ({
    label,
    subLabel,
    children,
    isDisabled = false,
    defaultExpanded = false,
}) => {
    const [expanded, setExpanded] = useState(defaultExpanded);

    // Auto-collapse when becoming disabled (e.g., switch to a user with no data)
    useEffect(() => {
        if (isDisabled && expanded) {
            setExpanded(false);
        }
    }, [isDisabled]);

    const handleToggle = () => {
        if (!isDisabled) {
            setExpanded(!expanded);
        }
    };

    return (
        <div
            className={`
                    border border-gray-200 rounded-lg bg-white shadow-sm transition-all duration-200 overflow-hidden
                    ${
                        !isDisabled
                            ? 'hover:border-gray-300 hover:shadow-md'
                            : 'bg-gray-50 border-gray-200'
                    }
                `}
        >
            {/* Header Section */}
            <div
                className={`
                        p-4 transition-all duration-200
                        ${
                            !isDisabled
                                ? 'cursor-pointer hover:bg-gray-50'
                                : 'cursor-default'
                        }
                    `}
                onClick={handleToggle}
            >
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        <div
                            className={`
                                w-8 h-8 rounded-full flex items-center justify-center mr-3 transition-colors duration-200
                                ${
                                    !isDisabled
                                        ? expanded
                                            ? 'bg-blue-100 text-blue-600'
                                            : 'bg-gray-100 text-gray-600 hover:bg-blue-50 hover:text-blue-500'
                                        : 'bg-gray-100 text-gray-400'
                                }
                            `}
                        >
                            <FontAwesomeIcon
                                icon={expanded ? faCaretDown : faCaretRight}
                                className="text-sm"
                            />
                        </div>
                        <div>
                            <h3
                                className={`text-lg font-semibold ${
                                    !isDisabled ? 'text-gray-800' : 'text-gray-400'
                                }`}
                            >
                                {label}
                            </h3>
                            {subLabel && (
                                <p
                                    className={`text-sm ${
                                        !isDisabled ? 'text-gray-600' : 'text-gray-400'
                                    }`}
                                >
                                    {subLabel}
                                    {!isDisabled && (
                                        <span className="ml-2 text-xs">
                                            {expanded
                                                ? 'Click to collapse'
                                                : 'Click to expand'}
                                        </span>
                                    )}
                                </p>
                            )}
                        </div>
                    </div>
                    {!isDisabled && (
                        <div
                            className={`
                                px-3 py-1 rounded-full text-xs font-medium
                                ${
                                    expanded
                                        ? 'bg-blue-100 text-blue-700'
                                        : 'bg-gray-100 text-gray-600'
                                }
                            `}
                        >
                            {expanded ? 'Expanded' : 'Collapsed'}
                        </div>
                    )}
                </div>
            </div>

            {/* Content Section */}
            <Collapse in={expanded}>
                <div className="border-t border-gray-200 bg-gray-50">{children}</div>
            </Collapse>
        </div>
    );
};

export default ToggleBlock;
